import React from "react";
import { Link } from "react-router-dom";

const ForgotPasswordLink = ({ clearState, ForgotPasswordLink, _ }) => (
  <div className="form-group forgot-password-link">
    <Link to={ForgotPasswordLink} onClick={clearState}>
      {_.ForgotPassword}?
    </Link>
  </div>
);

export default ForgotPasswordLink;
